import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Washer from "@/pages/services/Washer";
import Dryer from "@/pages/services/Dryer";
import Refrigerator from "@/pages/services/Refrigerator";
import Dishwasher from "@/pages/services/Dishwasher";
import RangeOven from "@/pages/services/RangeOven";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ServiceArea from "@/pages/areas/ServiceArea";
import NotFound from "@/pages/NotFound";
import OgRender from "@/pages/OgRender";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            {/* Bare OG render route (no Layout) for screenshot capture */}
            <Route path="/og-render/:lang/:slug" element={<OgRender />} />

            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="services" element={<Services />} />
              <Route path="services/washer" element={<Washer />} />
              <Route path="services/dryers" element={<Dryer />} />
              <Route path="services/refrigerator" element={<Refrigerator />} />
              <Route path="services/dishwasher" element={<Dishwasher />} />
              <Route path="services/range-oven" element={<RangeOven />} />
              <Route path="contact" element={<Contact />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog/:slug" element={<BlogPost />} />
              <Route path="service-areas/:slug" element={<ServiceArea />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
